export default __webpack_public_path__ + "static/media/painscale_8.63aaeeba.png";